import { createStore, createLogger, DispatchOptions } from 'vuex';
import { store as auth, AuthStore, State as AuthState } from '@/store/auth';
import { store as menu, MenuStore, State as MenuState } from '@/store/menu';
import { store as message, MessageStore, State as MessageState } from '@/store/messages';
import { store as loader, LoaderStore, State as LoaderState } from '@/store/loader';
import { store as grid, GridStore, State as GridState } from '@/store/grid';
import { ensureDefaultGridViewsInStorage } from '@/store/grid/default-views';
import { GridActionTypes } from '@/store/grid/action-types';
import { MenuMutationTypes } from '@/store/menu/mutation-types';

ensureDefaultGridViewsInStorage();

export type RootState = {
  auth: AuthState;
  menu: MenuState;
  loader: LoaderState;
  message: MessageState;
  grid: GridState;
};

export type Store = AuthStore<Pick<RootState, 'auth'>> &
  MenuStore<Pick<RootState, 'menu'>> &
  LoaderStore<Pick<RootState, 'loader'>> &
  MessageStore<Pick<RootState, 'message'>> &
  GridStore<Pick<RootState, 'grid'>> & {
    dispatch(type: string, payload?: any, options?: DispatchOptions): Promise<any>;
  };

// Plug in logger when in development environment
const debug = import.meta.env.MODE !== 'production';
const plugins = debug ? [createLogger({})] : [];

export const store = createStore<RootState>({
  plugins,
  modules: {
    menu,
    auth,
    loader,
    message,
    grid
  }
});

const idDaObra = (obra: any) => obra?.gesObraId ?? null;

let obraAtual = idDaObra((store.state as any)?.menu?.obraSelecionada);
let contratoAtual = (store.state as any)?.menu?.codigoContrato ?? null;

store.subscribe((mutation) => {
  let mudouContexto = false;

  if (mutation.type === MenuMutationTypes.SET_OBRA) {
    const nova = idDaObra(mutation.payload);
    mudouContexto = nova !== obraAtual;
    obraAtual = nova;
  }

  if (mutation.type === MenuMutationTypes.SET_CONTRATO) {
    const novo = mutation.payload ?? null;
    mudouContexto = novo !== contratoAtual;
    contratoAtual = novo;
  }

  if (mudouContexto) store.dispatch('grid/' + GridActionTypes.CLEAR_ALL_FILTERS);
});

export function useStore(): Store {
  return store as Store;
}
